<template lang="pug">
  div
    sidebar
      transition-group.group-list(name="list-complete" mode="out-in" tag="ul")
        li.list-complete-item(key="department")
          router-link.group-link(:to="{name: 'department' }")
            span {{$t('department')}}
    div.lmm-content-body
      router-view
</template>

<script>
import Sidebar from "@/components/mixins/sidebar"

export default {
  name: "department",
  components: { sidebar: Sidebar },
}
</script>
